import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)
// 重复请求相同路径警告
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
const routes = [
  {
    path: "/",
    redirect: "/signature/onLine",
  },
  {
    path: '/signature/onLine',
    component: () => import('./views/Step1')
  },
  {
    path: '/postpone/demo',
    component: () => import('./views/demo')
  },
  {
    path: '*',
    component: () => import('./views/404')
  }
]

const router = new VueRouter({
  mode: 'history',
  base:'yanqian',
  routes
})
export default router
